import * as z from 'zod/mini';
import { defineActor } from '@sigma/actors-core/Actor.js';
import { ChatEvent } from '@sigma/chat-common/ChatEvent.js';
import { FormInputValue } from '@sigma/common/forms/FormInput.js';
import { Id } from '@sigma/common/schema/Id.js';
import { GuestUser, PatientUser, StaffUser } from '../users.js';
export const ChatActor = defineActor({
    type: 'chat',
    parseId: BigInt,
    users: [PatientUser, StaffUser, GuestUser],
    requests: {
        /** Get chat events */
        getChat: {
            users: ['doctor', 'patient', 'guest'],
            input: z.object({
                /** Get chat events from this sequence onwards */
                fromSeq: z.optional(z.int32()),
            }),
            output: z.array(ChatEvent),
        },
        /** Answers a last asked question. */
        answerQuestion: {
            users: ['patient', 'guest', 'doctor'],
            input: z.object({
                /**
                 * Sequence number of the question.
                 * Used only to verify that the answer is for the correct question.
                 */
                questionSeq: z.int32(),
                /** Answer to the question */
                answer: FormInputValue,
            }),
            output: z.void(),
        },
        /** Sends a free-text message from patient or doctor, optionally with file attachments. */
        sendMessage: {
            users: ['patient', 'doctor'],
            input: z
                .object({
                /** Message content. Optional when files are attached. */
                message: z.optional(z.string().check(z.maxLength(10000))),
                /** IDs of previously uploaded files to attach. */
                fileIds: z.optional(z.array(Id)),
            })
                .check(z.refine(d => (d.message != null && d.message.trim().length > 0) ||
                (d.fileIds != null && d.fileIds.length > 0), 'Message or files required')),
            output: z.void(),
        },
        ping: {
            users: ['patient', 'guest', 'doctor'],
            input: z.void(),
            output: z.void(),
        },
        pingAndWait: {
            users: ['patient', 'guest', 'doctor'],
            input: z.void(),
            output: z.void(),
        },
    },
    events: {
        chatEvents: {
            schema: z.array(ChatEvent),
        },
    },
});
//# sourceMappingURL=ChatActor.js.map